<template>
  <div
    class="ui-input-editable__wrapper"
    style="justify-content: baseline; margin-right: auto"
    :style="isSmall ? 'width: 15rem' : ''"
  >
    <ButtonIconOnly
      class="ui-input-editable__edit-btn"
      icon="edit"
      @click-handler="edit"
      v-show="!editMode"
    >
      <VisibleText>rename theme</VisibleText>
    </ButtonIconOnly>
    <span
      class="ui-input-editable__content"
      style="margin-left: 0.5rem"
      v-if="!editMode"
      @click="selectHandler"
    >
      <div v-if="isBold" style="display: flex; text-align: left; margin-right: auto">
        <strong>
          {{ value }}
        </strong>
      </div>
      <div v-else style="display: flex; margin-right: auto">
        {{ value }}
      </div>
    </span>
    <input
      ref="input"
      class="ui-input-editable__content"
      type="text"
      :value="value"
      @blur="onBlur"
      @keydown.enter="onBlur"
      v-else
    />
  </div>
</template>

<script>
import ButtonIconOnly from '@/components/UI/Button/ButtonIconOnly.vue';

export default {
  name: 'InputEditable',
  props: {
    value: {
      type: String,
      default: () => '',
    },
    inputClass: {
      type: String,
      default: () => '',
    },
    isFocused: {
      type: Boolean,
      default: () => false,
    },
    selectHandler: {
      type: Function,
      default: () => {},
    },
    isBold: {
      type: Boolean,
      default: () => false,
    },
    isSmall: {
      type: Boolean,
      default: () => false,
    },
  },
  components: {
    ButtonIconOnly,
  },
  data() {
    return {
      editMode: false,
      oldValue: null,
    };
  },
  mounted() {
    // if (this.$props.isFocused) {
    //   setTimeout(
    //     function () {
    //       this.edit()
    //     }.bind(this),
    //     500
    //   )
    // }
    this.oldValue = this.$props.value;
    // this.oldValue = this.$props.value.trim()
  },
  methods: {
    edit() {
      this.editMode = true;
      this.$nextTick(() => this.$refs.input.focus());
    },
    onBlur: function (event) {
      const newValue = event.target.value.trim();
      if (this.oldValue !== newValue) {
        this.$emit('updateInput', newValue);
        this.oldValue = newValue;
      }
      this.editMode = false;
    },
  },
  watch: {
    isFocused: function (val) {
      if (val) {
        setTimeout(
          function () {
            this.edit();
          }.bind(this),
          300,
        );
      }
    },
  },
};
</script>
